import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-customer-acess-progress-dialog',
  templateUrl: './download-progress-dialog-component.component.html',
  styleUrls: ['./download-progress-dialog-component.component.sass'],
})
export class DownloadProgressDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { progress: number },
    private dialogRef: MatDialogRef<DownloadProgressDialogComponent>,
    private cdr: ChangeDetectorRef
  ) {}

  updateProgress(progress: number): void {
    this.data.progress = progress;
    this.cdr.detectChanges();
  }

  cancelDownload(): void {
    this.dialogRef.close('cancel');
  }

  closeDialog(): void {
    this.dialogRef.close('close'); // Fecha o modal sem interromper o download
  }
}
